/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  fillColor?: string
};

const SvgComponent: FC<IProps> = ({ width = 17, height = 14 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="map 1" clipPath="url(#clip0_673_9351)">
      <path
        id="Vector"
        d="M5.02031 0.904988C5.11771 0.869441 5.22396 0.863973 5.32431 0.891316L11.779 2.6003L16.029 1.0253C16.4953 0.853035 17 1.17022 17 1.63507V10.7898C17 11.0577 16.8229 11.2983 16.5543 11.3995L11.9797 13.0948C11.8823 13.1304 11.776 13.1358 11.6757 13.1085L5.22101 11.3995L0.971007 12.9745C0.504688 13.1468 0 12.8296 0 12.3648V3.21007C0 2.9421 0.177083 2.70147 0.44566 2.6003L5.02031 0.904988ZM0.944444 3.35772V12.0421L4.72222 10.6421V1.95772L0.944444 3.35772ZM11.3333 12.1077V3.39327L5.66667 1.8921V10.6066L11.3333 12.1077ZM12.2778 12.0421L16.0556 10.6421V1.95772L12.2778 3.35772V12.0421Z"
        fill="#908E8D"
      />
    </g>
    <defs>
      <clipPath id="clip0_673_9351">
        <rect width="17" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgComponent;
